var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',_vm._b({class:_vm.size,attrs:{"props":_vm.casProps,"size":_vm.size,"options":_vm.options,"collapse-tags":_vm.collapseTags,"placeholder":"全部"},on:{"change":_vm.change,"visible-change":val => {
			_vm.$emit('visibleChange', val);
		}},scopedSlots:_vm._u([{key:"default",fn:function({ data }){return [_c('span',[_vm._v(_vm._s(data.name))])]}}]),model:{value:(_vm.depts),callback:function ($$v) {_vm.depts=$$v},expression:"depts"}},'el-cascader',_vm.$listeners,false))
}
var staticRenderFns = []

export { render, staticRenderFns }